<markant-button
  id="button-table-column-select"
  data-cy="button-table-column-select"
  colorScheme="primary"
  variant="clear"
  (click)="togglePopover()"
>
  <markant-icon
    icon="m_table-edit"
    class="login-icon"
    slot="icon-leading"
  ></markant-icon>
  {{ 'tables.columnLayout.button' | transloco }}
</markant-button>

<markant-platform-modal-bridge>
  <markant-popover
    class="table-column-select"
    placement="bottom-end"
    trigger="click"
    distance="12"
    for="button-table-column-select"
    [visible]="open"
    (backdrop)="closePopover()"
  >
    <div class="table-column-select-container">
      <h5 class="table-column-select-title">
        {{ 'tables.columnLayout.title' | transloco }}
      </h5>

      <markant-searchbar
        class="table-column-select-searchbar"
        data-cy="searchbar-table-column-select"
        [placeholder]="'common.search' | transloco"
        (valueChange)="onSearchChanged($any($event).detail)"
      ></markant-searchbar>
      <markant-list class="table-column-select-list">
        @for (column of columns(); track column.columnId) {
          <markant-list-item class="table-column-select-list-item">
            <markant-checkbox
              class="checkbox"
              slot="markant-list-item-leading"
              [checked]="selectedColumns | arrayIncludes: column.columnId"
              [disabled]="
                selectedColumns.includes(column.columnId) &&
                selectedColumns.length <= 1
              "
              (checkedChange)="onSelectionChanged(column.columnId)"
            >
              {{ column.label }}
            </markant-checkbox>
          </markant-list-item>

          @if (preselectedColumns().at(-1) === column.columnId) {
            <markant-list-divider></markant-list-divider>
          }
        }
      </markant-list>
      <div class="table-column-select-footer">
        <markant-button
          colorScheme="primary"
          variant="clear"
          data-cy="button-table-column-select-reset"
          (click)="reset()"
        >
          {{ 'common.reset' | transloco }}
        </markant-button>
        <markant-button
          colorScheme="primary"
          data-cy="button-table-column-select-apply"
          (click)="apply()"
        >
          {{ 'common.apply' | transloco }}
        </markant-button>
      </div>
    </div>
  </markant-popover>
</markant-platform-modal-bridge>
